import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoWa: CultureInfo = {
  name: 'wa',
  displayName: 'walon',
  iso3LanguageCode: 'wln',
  iso2LanguageCode: 'wa',
  ietfLanguageTag: 'wa',
  parent: null
};
